// extracted by mini-css-extract-plugin
export default {"narrow-sidebar":"NarrowView-module__narrow-sidebar___TEURH"};